import React, { useState, useEffect } from "react";
import "./index.css";

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  const handleConsent = () => {
    localStorage.setItem("hasConsentedToCookies", true);
    setIsVisible(false);
  };

  useEffect(() => {
    const hasConsented = localStorage.getItem("hasConsentedToCookies");
    if (!hasConsented) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) return null;

  return (
    <div className="cookie-consent bgc-3968">
      <div className="cookie-consent__container">
        <div className="cookie-consent__row">
          <div className="cookie-consent__col">
            <p className="cookie-consent__text">
              Our website uses cookies for Single Sign-On (SSO) related
              functionalities and to ensure proper functioning.
              <br />
              By continuing to use this site, you consent to our use of cookies.
              Please enable cookies in your browser settings to continue.
            </p>
          </div>
          <div className="cookie-consent__col-auto">
            <button
              className="cookie-consent__button btn-c-521 btn-rd"
              style={{ width: 100 }}
              onClick={handleConsent}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
